<template>
  <custom-dialog class="portal-add-bill-dialog" :title="model.title" width="750px" :visible="visible" v-on="$listeners">
    <div class="dialog-body" style="padding-top: 0 !important">
      <div class="content">
        <div class="base-info">
          <div class="title">{{ $t('apip_step11_zzxx') }}</div>
          <el-form label-position="top" :model="form" :rules="rules" :validate-on-rule-change="false" ref="form">
            <el-form-item :label="$t('apip_step11_shou_kuan_fang')">
              <el-input v-model="form.sellerName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item :label="$t('apip_step11_skfzh')" prop="sellerAccount">
              <custom-select
                v-if="dicCodeName.bank_branch"
                v-model="form.sellerAccount"
                url="PartnerBankcardListByOrgId"
                :params="{ orgId: receivableOrgId }"
                :props="{ label: 'label', value: 'depositNumber' }"
                @getList="onSellerAccountGetList"
                :dataFilter="bankListFilter"
              ></custom-select>
            </el-form-item>
            <el-form-item :label="$t('apip_step11_fu_kuan_fang')">
              <el-input v-model="form.buyerName" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item :label="$t('apip_step11_fkfzh')" prop="buyerAccount" class="row">
              <custom-select
                v-if="dicCodeName.bank_branch"
                v-model="form.buyerAccount"
                url="PartnerBankcardListByOrgId"
                :params="{ orgId: payableOrgId }"
                :props="{ label: 'label', value: 'depositNumber' }"
                @getList="onBuyerAccountGetList"
                :dataFilter="bankListFilter"
                ref="bank"
              ></custom-select>
              <div class="item" @click="addBank">{{ $t('com_add') }}</div>
            </el-form-item>
            <el-form-item :label="$t('apip_step11_fu_kuan_jin_e')">
              <el-input v-model="form.totalAmount" type="number"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="preview-info">
          <div class="preview-content">
            <div class="line"></div>
            <div class="info">
              <div class="title">{{ $t('apip_step11_xin_xi_yu_lan') }}</div>
              <div class="details">
                <div class="item">
                  <div class="key">{{ $t('apip_step11_zhmc') }}:</div>
                  <div class="val">{{ copyInfo.accountName }}</div>
                </div>
                <div class="item">
                  <div class="key">{{ $t('apip_step11_yhzh') }}:</div>
                  <div class="val">{{ copyInfo.account }}</div>
                </div>
                <div class="item">
                  <div class="key">{{ $t('apip_step11_kai_hu_yin_hang') }}:</div>
                  <div class="val">{{ copyInfo.bank }}</div>
                </div>
                <div class="item">
                  <div class="key">{{ $t('apip_step11_zzbz') }}:</div>
                  <div class="val">
                    {{ copyInfo.tradeCode }}
                    <span class="red">(*{{ $t('apip_step11_dksqbz') }})</span>
                  </div>
                </div>
              </div>
              <div class="amount">
                <div class="key">{{ $t('apip_step11_zzje') }}:</div>
                <div class="val">￥{{ form.totalAmount || 0 }}</div>
              </div>
              <el-button type="warning" class="copy" @click="onCopy">
                <i class="icon icon-copy1"></i>
                <span>{{ $t('apip_step11_fu_zhi') }}</span>
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bank-card-dialog v-if="addBankVisible" @close="addBankVisible = false" :model="addBankModel" @success="onAddBankSuccess"></bank-card-dialog>
  </custom-dialog>
</template>

<script>
// 新增账单
import dialogMixins from '@/mixins/dialog_mixins';
import bankCardDialog from './bank_card_dialog.vue';

// apip_step11_zzxx: 转账信息// apip_step11_xin_xi_yu_lan: 信息预览// apip_step11_zhmc: 账户名称// apip_step11_yhzh: 银行账号// apip_step11_kai_hu_yin_hang: 开户银行// apip_step11_zzbz: 转账备注// apip_step11_dksqbz: 打款时请备注// apip_step11_zzje: 转账金额// apip_step11_fu_zhi: 复制// apip_step11_shou_kuan_fang: 收款方// apip_step11_skfzh: 收款方账户// apip_step11_fu_kuan_fang: 付款方// apip_step11_fkfzh: 付款方账户// apip_step11_fu_kuan_jin_e: 付款金额// apip_step11_xzyh: 新增银行// apip_step11_zhmc_1: 账户名称：// apip_step11_yhzh_1: 银行账户：// apip_step11_kai_hu_hang: 开户行：// apip_step11_zzbz_1: 转账备注：// apip_step11_fu_kuan_jin_e_1: 付款金额：￥

export default {
  name: 'addPayInfoPublicStep1Dialog',
  mixins: [dialogMixins],
  props: {
    totalAmount: [Number, String],
    paymentCode: [Number, String],
  },
  components: {
    bankCardDialog,
  },
  computed: {
    rules() {
      return {
        sellerAccount: [{ required: true, message: this.$t('com_required') }, { max: 20 }],
        buyerAccount: [{ required: true, message: this.$t('com_required') }, { max: 20 }],
      };
    },
    receivableOrgId() {
      const outerItem = this.model.data && this.model.data.outerItem ? this.model.data.outerItem : {};
      // return this.model.type === 'add' ? outerItem.receivableOrgId : this.model.data.form.sellerId;
      return outerItem.receivableOrgId;
    },
    payableOrgId() {
      const outerItem = this.model.data && this.model.data.outerItem ? this.model.data.outerItem : {};
      // return this.model.type === 'add' ? outerItem.payableOrgId : this.model.data.form.buyerId;
      return outerItem.payableOrgId;
    },
    buyerName() {
      const outerItem = this.model.data && this.model.data.outerItem ? this.model.data.outerItem : {};
      // return this.model.type === 'add' ? outerItem.payableOrgName : this.model.data.form.buyerName;
      return outerItem.payableOrgName;
    },
    sellerName() {
      const outerItem = this.model.data && this.model.data.outerItem ? this.model.data.outerItem : {};
      // return this.model.type === 'add' ? outerItem.receivableOrgName : this.model.data.form.sellerName;
      return outerItem.receivableOrgName;
    },
    copyInfo() {
      /**
       * 账户名称
       * 银行账户
       * 开户行
       * 转账备注
       * 付款金额
       */
      const ret = {};
      const {
        buyerAccount,
        sellerAccount,
        // 转账金额
        totalAmount,
      } = this.form;

      // 账户名称
      ret.accountName = this.form.sellerName;

      // 付款人
      ret.buyerAccount = buyerAccount;
      // 收款人
      ret.sellerAccount = sellerAccount;

      // 付款金额
      ret.totalAmount = totalAmount;

      // 转账备注
      ret.tradeCode = this.paymentCode.slice(-6);

      const sellerItem = this.sellerAccountList.find(item => item.depositNumber === this.form.sellerAccount);
      if (sellerItem) {
        // 开户行
        const bank = this.dicCodeName.bank_branch[sellerItem.bankCode] || sellerItem.bankName;

        const {
          // 支行
          depositBank,
          // 银行账号
          depositNumber,
        } = sellerItem;

        // 银行账户
        ret.account = depositNumber;
        // 开户行
        ret.bank = `${bank}${depositBank}`;
      }
      return ret;
    },
  },
  data() {
    return {
      form: {
        // 付款方账号
        buyerAccount: '',
        // 付款方
        buyerName: '',
        // 收款方
        sellerName: '',
        // 收款方账号
        sellerAccount: '',
        // 交易日期
        totalAmount: '',
        // 交易日期
        tradeFinishTime: '',
        // 摘要
        tradeCode: '',
        tradeId: '',
      },
      transactionReceipt: [],
      sellerAccountList: [],
      selectDate: '',
      initValue: '',
      addBankModel: {},
      addBankVisible: false,
    };
  },
  methods: {
    onAddBankSuccess() {
      this.$refs.bank.getSelectList();
    },
    addBank() {
      this.addBankModel = {
        type: 'add',
        title: this.$t('apip_step11_xzyh'),
      };
      this.addBankVisible = true;
    },
    onBuyerAccountGetList(list) {
      this.buyerAccountList = list;
      if (this.form.buyerAccount) {
        return;
      }
      const item = list.find(obj => obj.isDefault);
      if (item) {
        this.form.buyerAccount = item.depositNumber;
      }
    },
    onCopy() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const copyInfo = this.copyInfo;
          const ret = [
            // 账户名称
            `${this.$t('apip_step11_zhmc_1')}${copyInfo.accountName}`,
            // 银行账户
            `${this.$t('apip_step11_yhzh_1')}${copyInfo.account}`,
            // 开户行
            `${this.$t('apip_step11_kai_hu_hang')}${copyInfo.bank}`,
            // 转账备注
            `${this.$t('apip_step11_zzbz_1')}${copyInfo.tradeCode}`,
            // 付款金额
            `${this.$t('apip_step11_fu_kuan_jin_e_1')}${copyInfo.totalAmount}`,
          ];

          this.$copyToClip(ret.join('\r\n'));

          const emitData = this.getEmitData();

          this.$emit('confirm', emitData);
          this.visible = false;
        }
      });
    },
    getEmitData() {
      // 收款方（卖方）
      const sellerItem = this.sellerAccountList.find(item => item.depositNumber === this.form.sellerAccount);
      const { buyerName, sellerName, sellerAccount, totalAmount } = this.form;
      const ret = {
        ...this.form,
        buyerName,
        sellerName,
        sellerAccount,
        totalAmount,
        attachs: [],
        tradeMethod: this.dicCodeValue.payment_class.public_account,
      };
      if (sellerItem) {
        ret.sellerBank = sellerItem.depositBank;
      }
      ret.buyerId = this.payableOrgId;
      ret.sellerId = this.receivableOrgId;
      ret.buyerTradeRemark = this.paymentCode.slice(-6);
      return ret;
    },
    init() {
      const form = this.model.data.form;
      this.form.buyerName = this.buyerName;
      this.form.sellerName = this.sellerName;
      this.form.tradeCode = this.paymentCode;
      this.$setFormatData(this.form, form);
      if (this.totalAmount) {
        this.form.totalAmount = this.totalAmount;
      }
    },
    onSellerAccountGetList(list) {
      this.sellerAccountList = list;
      if (this.form.sellerAccount) {
        return;
      }
      const item = list.find(obj => obj.isDefault);
      if (item) {
        this.form.sellerAccount = item.depositNumber;
      }
    },
    // 格式化银行列表数据，使label为：账号/支行
    bankListFilter(list) {
      list.forEach((item) => {
        const depositBank = item.depositBank;
        const depositNumber = item.depositNumber;
        item.label = [depositNumber, depositBank].join('/');
      });
      return list;
    },
  },
  mounted() {
    this.mergeLanguage(null, 'portal_add_pay_info_public_step1_dialog');
    this.getDictionaryCodeValue('payment_class');
    this.getDictionaryCodeName('bank_branch', () => {
      this.init();
    });
  },
};
</script>

<style lang="scss">
.portal-add-bill-dialog {
  .el-dialog .el-dialog__body .el-form-item {
    margin-bottom: 16px;
  }
  .el-form--label-top .el-form-item__label {
    padding-bottom: 0;
  }

  .row {
    position: relative;
    .el-form-item__content {
      position: static;
    }
    .item {
      line-height: 17px;
      height: 17px;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 100;
      cursor: pointer;
      color: #00a0d9;
      .label {
        float: left;
        padding-left: 5px;
        font-size: 12px;
        text-decoration: underline;
      }
    }
  }

  .copy {
    width: 100%;
    margin-top: 24px;
  }
  .content {
    overflow: hidden;
    .base-info {
      float: left;
      width: 317px;
      padding-bottom: 50px;

      .title {
        color: #202945;
        line-height: 17px;
        font-size: 12px;
        font-weight: bold;
        margin-bottom: 16px;
      }
    }

    .preview-info {
      overflow: hidden;
      padding-left: 48px;
      padding-top: 27px;
      margin-bottom: 48px;

      .preview-content {
        width: 313px;
        border-radius: 4px;
        overflow: hidden;
        border: 1px solid #f5f5f5;

        .line {
          width: 100%;
          height: 3px;
          background: #00a0d9;
        }
        .info {
          padding: 24px 24px 32px 24px;
          .title {
            color: #202945;
            line-height: 20px;
            font-size: 14px;
            font-weight: bold;
          }

          .details {
            margin-top: 24px;
            .red {
              color: #eb5a5a;
            }
            .item {
              &:nth-child(n + 2) {
                margin-top: 8px;
              }
              overflow: hidden;
              line-height: 21px;
              .key {
                float: left;
                font-size: 14px;
                color: #4d4d4d;
              }
              .val {
                padding-left: 16px;
                font-size: 14px;
                color: #1a1a1a;
                overflow: hidden;
                word-break: break-all;
                white-space: normal;
              }
            }
          }

          .amount {
            line-height: 27px;
            overflow: hidden;
            margin-top: 24px;
            .key {
              float: left;
              color: #4d4d4d;
              font-size: 14px;
            }
            .val {
              overflow: hidden;
              padding-left: 16px;
              color: #00a0d9;
              font-size: 18px;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
}
</style>
copy
